module.exports = __webpack_public_path__ + "static/media/balenciaga-red-Oversized-Quilted-Shell-Down-Jacket.a15c71cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/balenciaga-red-Oversized-Quilted-Shell-Down-Jacket.png
// module id = 317
// module chunks = 0